import React, { useState } from "react";
import { Direcciones } from "../../components/Otros/Direcciones";
import { PlaceholderTabla } from "../../components/Otros/Placeholder";
import { PrecalificadoresPorDireccion } from "../../components/Otros/PrecalificadoresPorDireccion";
import { useForm } from "../../hooks/useForm";
import {buscar} from "../../utils/Datos";
import {Toolbar} from "../../layout/Toolbar/Toolbar";
import { NavLink } from "react-router-dom";
const SelectDirecciones = ({ updateValue }) => {
  return <Direcciones updateValue={updateValue} />;
};

const SelectPrecalificador = ({ idDireccion, updateValue,proceso }) => {
  return (
    <PrecalificadoresPorDireccion
      direccion={idDireccion}
      idProcess={proceso}
      updateValue={updateValue}
    />
  );
};



export const BuscarCalificacion = () => {
  const [lista, setLista] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [formValues, handleInputChange, reset, updateValue, updateState] =
    useForm({
      ano: "null",
      rut: "",
      proceso: "",
      direccion: null,
      precalificadores: null,
    });

  const { ano, rut, proceso, direccion, precalificadores } = formValues;

  const handleClick = async () => {
    setCargando(true);

    await buscar({
      year_process: ano,
      id_process: proceso,
      rutOfficer: rut,
      id_Dmunicipal: direccion,
      id_prequalifiers: precalificadores,
    }).then((lista) => {
      setLista(lista);
      setCargando(false);
    });
  };

  let toolbarEnlaces = [
    {
      muted: "false",
      to: "/home",
      title: "Home",
      bullet: "false",
    },
    {
      muted: "true",
      to: "/buscarCalificacion",
      title: "Buscar calificación",
      bullet: "false",
    },]

  return (
    <>
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        <Toolbar title='BUSCAR CALIFICACIÓN' enlaces={toolbarEnlaces}></Toolbar>
        <div className="post d-flex flex-column-fluid" id="kt_post">
          <div className="container-xxl">
            <div className="row gy-5 g-xl-8">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bolder text-dark">
                        FILTROS DE BUSQUEDA
                      </span>
                    </h3>
                  </div>
                  <div className="card-body">
                    <form
                      data-kt-search-element="advanced-options-form"
                      className="pt-1 "
                    >
                      <div className="row mb-8">
                        <div className="col-lg-4 col-sm-12 ">
                          <label>Año del proceso</label>
                          <select
                            className="form-select mb-5"
                            aria-label="Select example"
                            disabled=""
                            onChange={(e)=>{
                              updateState([
                                { name: "ano", value: e.target.value }
                              ])
                            
                            }}
                          >
                            
                            <option value="">Seleccionar...</option>
                            <option value="2022">2022</option>
                            <option value="2023">2023</option>
                            <option value="2024">2024</option>
                            <option value="2025">2025</option>
                            <option value="2026">2026</option>
                            <option value="2027">2027</option>
                          </select>
                        </div>
                        <div className="col-lg-4 col-sm-12 ">
                          <label>Rut del funcionario</label>
                          <input
                            type="text"
                            className="form-control mb-5"
                            placeholder="RUT FUNCIONARIO"
                            disabled=""
                            onChange={(e)=>{
                              updateState([
                                { name: "rut", value: e.target.value }
                              ])
                              console.log('cambiado',rut);
                            }}
                          />
                        </div>
                        <div className="col-lg-4 col-sm-12 ">
                          <label>N° del proceso</label>
                          <input
                            type="text"
                            className="form-control mb-5"
                            placeholder="N° Proceso"
                            disabled=""
                            onChange={(e)=>{
                              updateState([
                                { name: "proceso", value: e.target.value }
                              ])

                              console.log('cambiado',proceso);
                            }}
                          />
                        </div>
                        <div className="col-lg-4 col-sm-12 ">
                          <label>Dirección municipal</label>
                          <SelectDirecciones updateValue={updateValue} />
                          
                        </div>
                        <div className="col-lg-4 col-sm-12 ">
                          <label>Precalificador</label>
                          <SelectPrecalificador
                            proceso={proceso}
                            updateValue={updateValue}
                            idDireccion={direccion}
                          />
                          
                        </div>
                        <div className="card-footer d-flex justify-content-end py-6 px-9 mt-3">
                          <button
                            type="button"
                            onClick={handleClick}
                            className="btn btn-sm fw-bolder btn-primary"
                          >
                             Buscar Calificación
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-xl-12 ">
                <div className="card ">
                  <div className="card-header ">
                    <h3 className="card-title align-items-start flex-column ">
                      <span className="card-label fw-bolder text-dark ">
                        RESULTADOS DE BÚSQUEDA / PROCESOS ACTIVOS
                      </span>
                    </h3>
                  </div>
                  <div className="card-body ">
                    <div className="table-responsive">
                      {cargando ? (
                        <PlaceholderTabla></PlaceholderTabla>
                      ) : (
                        <table className="table table-rounded table-striped border gy-7 gs-7">
                          <thead>
                            <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                              <th>Año Proceso</th>
                              <th>Nombre</th>
                              <th>Periodo</th>
                              <th>Ver proceso</th>
                            </tr>
                          </thead>
                          <tbody>
                            {lista.length > 0 ? (
                              lista.map((calificacion) => {
                                return (
                                  <tr key={calificacion.id_qualifications}>
                                    <td>{calificacion.year_process}</td>
                                    <td>{calificacion.nameOficcer}</td>
                                    <td>Faltan datos</td>
                                    <td>
                                      <NavLink
                                      to={'/verCalificacion/'+calificacion.id_qualifications}
                                      className="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark"
                                      >
                                        CU:66 ver
                                      </NavLink>
                                     
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan={4}>No hay datos para mostrar</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
